// removed by extract-text-webpack-plugin
module.exports = {"react-tabs":"react-tabs","react-tabs__tab-list":"react-tabs__tab-list","react-tabs__tab":"react-tabs__tab","react-tabs__tab--selected":"react-tabs__tab--selected","react-tabs__tab--disabled":"react-tabs__tab--disabled","react-tabs__tab-panel":"react-tabs__tab-panel","react-tabs__tab-panel--selected":"react-tabs__tab-panel--selected"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-tabs/style/react-tabs.scss
// module id = ./node_modules/react-tabs/style/react-tabs.scss
// module chunks = 0